import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);
  const isActive = (path: string) => location.pathname === path ? 'active' : '';

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">

          {/* Logo */}
          <Link to="/" className="logo" onClick={closeMenu}>
            <img src="/logo.png" alt="Clínica CIS - Clínica Integrada de Saúde" className="logo-img" />
            <div className="logo-text">
              <span className="logo-title">Clínica CIS</span>
              <span className="logo-subtitle">Clínica Integrada de Saúde</span>
            </div>
          </Link>

          {/* Navegação */}
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className={`nav-link ${isActive('/')}`} onClick={closeMenu}>Início</Link>
              </li>
              <li className="nav-item">
                <Link to="/servicos" className={`nav-link ${isActive('/servicos')}`} onClick={closeMenu}>Serviços</Link>
              </li>
              <li className="nav-item">
                <Link to="/sobre" className={`nav-link ${isActive('/sobre')}`} onClick={closeMenu}>Sobre Nós</Link>
              </li>
              <li className="nav-item">
                <Link to="/contato" className={`nav-link ${isActive('/contato')}`} onClick={closeMenu}>Contato</Link>
              </li>
              <li className="nav-item">
                <Link to="/agendamento" className="nav-link btn-appointment" onClick={closeMenu}>
                  <i className="fas fa-calendar-plus"></i> Agendar
                </Link>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <a href="tel:+5569992246189" className="phone-link" title="Ligar para a clínica">
              <i className="fas fa-phone"></i>
              <span>(69) 99224-6189</span>
            </a>
            <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}>
                <span></span><span></span><span></span>
              </span>
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </header>
  );
};

export default Header;
